module.exports = __webpack_public_path__ + "img/logo-light-icon.de1f40a6.png";